// src/services/visitService.js
import axiosInstance from './axiosServicesVisit.js';

export const getVisitStatistics = (startDate, endDate, doctorType, delegateIds) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (doctorType !== undefined && doctorType !== null && String(doctorType).toLowerCase() !== 'all') {
        params.doctorType = String(doctorType);
    }
    if (delegateIds !== undefined && delegateIds !== null && delegateIds !== '') {
        params.delegateIds = delegateIds;
    }
    console.log('[VisitService FRONTEND] Appel /visits/statistics avec params:', params);
    return axiosInstance.get('/visits/statistics', { params });
};

export const getVisitsByDelegate = (delegateId, page = 1, limit = 10, startDate, endDate, personId, specialtyId, regionId, doctorType, personType) => {
    if (delegateId === undefined || delegateId === null) {
        return Promise.reject(new Error('Delegate ID is required'));
    }
    const params = { page: String(page), limit: String(limit) };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (personId !== undefined && personId !== null && String(personId).toLowerCase() !== 'all' && String(personId) !== '') params.personId = String(personId);
    if (specialtyId !== undefined && specialtyId !== null && String(specialtyId).toLowerCase() !== 'all' && String(specialtyId) !== '') params.specialtyId = String(specialtyId);
    if (regionId !== undefined && regionId !== null && String(regionId).toLowerCase() !== 'all' && String(regionId) !== '') params.regionId = String(regionId);
    if (doctorType !== undefined && doctorType !== null && String(doctorType).toLowerCase() !== 'all' && String(doctorType) !== '') params.doctorType = String(doctorType);
    
    // --- CORRECTION : AJOUT DU PARAMÈTRE ICI ---
    if (personType !== undefined && personType !== null && String(personType).toLowerCase() !== 'all' && String(personType) !== '') {
        params.personType = String(personType);
    }
    // ------------------------------------------

    console.log(`[VisitService FRONTEND] Appel getVisitsByDelegate pour ID ${delegateId} avec params:`, params);
    return axiosInstance.get(`/visits/delegate/${delegateId}`, { params });
};

export const getDoctorVisitStatusByOtherDelegates = (personId, excludeDelegateId, startDate, endDate) => {
    if (personId === undefined || personId === null || excludeDelegateId === undefined || excludeDelegateId === null) {
        return Promise.reject(new Error('Person ID and Exclude Delegate ID are required'));
    }
    const params = { excludeDelegateId: String(excludeDelegateId) };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return axiosInstance.get(`/visits/doctor-visit-status/${personId}`, { params });
};

export const getDistinctFilterOptionsForDelegate = (delegateId, startDate, endDate) => {
    if (delegateId === undefined || delegateId === null) {
        return Promise.reject(new Error('Delegate ID is required'));
    }
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return axiosInstance.get(`/visits/delegate/${delegateId}/distinct-filter-options`, { params });
};

export const getMissedVisitsGrouped = (filters = {}) => {
    if (!filters.startDate || !filters.endDate) {
        return Promise.reject(new Error('Start date and end date are required in filters object'));
    }

    const params = {
        startDate: filters.startDate,
        endDate: filters.endDate
    };

    if (filters.delegateIds) {
        params.delegateIds = filters.delegateIds;
    }

    // ⚡ AJOUT OBLIGATOIRE DE cycleIds ⚡
    if (filters.cycleIds) {
        params.cycleIds = filters.cycleIds;
    }

    if (filters.doctorType !== undefined && filters.doctorType !== null && String(filters.doctorType).toLowerCase() !== 'all' && String(filters.doctorType) !== '') {
        params.doctorType = String(filters.doctorType);
    }

    if (filters.isPartner !== undefined && filters.isPartner !== null && String(filters.isPartner) !== 'all') {
        params.isPartner = String(filters.isPartner);
    }

    if (filters.otherInteractionStatusFilter) {
        params.otherInteractionStatusFilter = String(filters.otherInteractionStatusFilter);
    }

    return axiosInstance.get('/visits/missed', { params });
};


export const exportVisitStatistics = (startDate, endDate, doctorType, delegateIds) => {
    return axiosInstance.get('/visits/statistics/export', {
        params: { startDate, endDate, doctorType, delegateIds },
        responseType: 'blob', // <-- C'est CRUCIAL ! Axios traitera la réponse comme un fichier binaire.
    });
};

export const exportMissedVisits = (filters = {}) => {
    if (!filters.startDate || !filters.endDate) {
        return Promise.reject(new Error('Start date and end date are required for export'));
    }

    const params = {
        startDate: filters.startDate,
        endDate: filters.endDate
    };
    if (filters.delegateIds) params.delegateIds = filters.delegateIds;
    if (filters.doctorType !== undefined) params.doctorType = String(filters.doctorType);
    if (filters.personId !== undefined) params.personId = String(filters.personId);
    if (filters.otherInteractionStatusFilter) params.otherInteractionStatusFilter = filters.otherInteractionStatusFilter;
    if (filters.isPartner !== undefined && filters.isPartner !== 'all') params.isPartner = String(filters.isPartner);

    return axiosInstance.get('/visits/missed/export', {
        params,
        responseType: 'blob',
    });
};

export const getConsecutiveMissedVisits = (params) => {
    // Retirez le "/" devant "visits" pour qu'il utilise le "v1" par défaut de l'instance
    return axiosInstance.get('visits/consecutive-missed', { params });
};